export function dataInRequest(params = {}) {
    return {
        type: '@manuttrocarlocoabast/DATA_IN_REQUEST',
        payload: { params },
    };
}

export function findData(id) {
    return {
        type: '@manuttrocarlocoabast/FIND_DATA',
        payload: { id },
    };
}

export function failedRequest() {
    return {
        type: '@manuttrocarlocoabast/FAILED_REQUEST',
    };
}


export function updateData(data, params) {
    return {
        type: '@manuttrocarlocoabast/UPDATE_DATA',
        payload: { data, params },
    };
}


export function storeData(data, params) {
    return {
        type: '@manuttrocarlocoabast/STORE_DATA',
        payload: { data, params },
    };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
    return {
        type: '@manuttrocarlocoabast/SUCCESS_IN_REQUEST',
        payload: { data, page, pageSize, totalCount, totalPages },
    };
}

export function successRequest(data) {
    return {
        type: '@manuttrocarlocoabast/SUCCESS_REQUEST',
        payload: { data },
    };
}

export function successRemove(params) {
    return {
        type: '@manuttrocarlocoabast/SUCCESS_REMOVE',
        payload: { params },
    };
}

export function recordFiltering(params) {
    return {
        type: '@manuttrocarlocoabast/RECORD_FILTERING',
        payload: { params },
    };
}